<template>
  <div class="square">
    <div
      class="content"
      :class="{'d-flex justify-content-center align-items-center' : centered}"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    centered: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.square {
  position: relative;
}

.square:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

.square .content {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
</style>
